module.exports["suggestions"] = "_suggestions_5873f8";
module.exports["focus-visible"] = "_focus-visible_5873f8";
module.exports["icon"] = "_icon_5873f8";